import React from 'react';
import { Global, css } from '@emotion/react';
import { mqMin } from 'utils/responsive';

const variables = css`
    :root {
        /* Font */
        --font-xx-small: 8px;
        --font-x-small: 9px;
        --font-small: 10px;
        --font-default: 12px;
        --font-medium: 14px;
        --font-large: 16px;
        --font-x-large: 18px;
        --font-xx-large: 22px;
        --font-xxx-large: 28px;
        --font-xxxx-large: 32px;
        --font-xxxxx-large: 36px;
        --font-xxxxxx-large: 42px;
        --font-bold: 600;
        --font-extra-bold: 700;

        /* Color */
        --white: #ffffff;
        --warn: #ea5550;
        --warn-pale: #fce4d6;
        --golden-yellow: #f6ae54;
        --main-color-dark: rgba(255, 127, 80, 0.8);
        --ash-gray: #9fa09e;
        --pale-gray: #c9c9c4;
        --black: #000000;
        --dark-blue: #1e4e66;
        --pale-blue: #55b6e6;
        --soft-blue: #e3f4ff;
    
        --blue: #1695d4;
        --orange: #ed793e;
        --lightblue: #dfecf3;
        --beige: #d5d5d533;
        --green: #228b22;

        --main-color-blue: #1a96d5;
        --main-color-blue-light: #55b6e6;
        --main-color-gold: #bead73;
        --bg-color-dark: #d8dae9;
        --bg-color-light: #ebedf7;
        --main-bg-color: #e9e5de;
        --main-font-color: #625e5c;
        --brown: #5c4744;
        --gold: #e8c17a;
        --gray: #dbdbdb;
        --primary: #ee793f;
        --light-orange: #EF9629;
        --color-navy: #1e4e66;
        --color-orange: #ee793f;
        --cream: #FFFBC9;
        --supporter-green: #00A86B;
        --supporter-green-light: #A0D6B4;
        --supporter-bg: #E8F5E9;

        --font-family: font-family: YuGothic, 'Yu Gothic', sans-serif;
        --font-family--en: 'Roboto Condensed', sans-serif;

        --height-top-header: 101px;
        ${mqMin('NARROW')} {
            --height-top-header: 148px;
        }
        --height-pc-header: 50px;
        --height-sp-header: 60px;
        --width-pc-side-menu: 200px;

        /* z-index */
        --sticky: 1;
        --z-validation-error: 1;
        --z-selected-gift-box-modal: 5;
        --z-room-detail-header: 10;
        --search-header: 50;
        --z-room-detail: 60;
        --mobile-menu-overlay: 89;
        --mobile-menu: 90;
        --mobile-menu-other: 91;
        --drawer: 100;
        --z-lp-header: 200;
        --z-lp-splash: 201;
        --drawer-close: 101;
        --z-lp-cookie: 400;
        --tooltip: 1000;
        --z-modal-progress-bar: 2001;
        --z-index-sidebar: 2000;
        --modal: 3100;
        --z-error-notice: 100000;
    }
`;

export const Variables: React.FC = () => {
    return (
        <Global
            styles={css`
                ${variables}
            `}
        />
    );
};
